import React, { useCallback, useState } from 'react';
import { Card } from 'antd';
import { FaFilter, FaSyncAlt } from 'react-icons/fa';
import { v4 } from 'uuid';
import Table from '../../../components/Table';
import LogWebhookCategoryFilters from '../../../components/LogWebhookCategoryFilters';
import { useApi } from '../../../hooks/api';
import { ILogWebhookCategory } from '../../../interfaces/logWebhookCategory';
import { IActionHeaderConfig, ITableColumn } from '../../../interfaces/table';

const LogWebhookCategory: React.FC = () => {
  const { api } = useApi();
  const [loading, setLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [webhookCategoryLogs, setWebhookCategoryLogs] = useState<
    ILogWebhookCategory[]
  >([]);
  const [filters, setFilters] = useState({
    start_date: '',
    end_date: '',
  });

  const loadLogs = useCallback(
    async (
      start_date = filters.start_date,
      end_date = filters.end_date,
    ) => {
      if (!start_date || !end_date) {
        setWebhookCategoryLogs([]);
        return;
      }

      setLoading(true);
      try {
        const response = await api.get('/logs/webhook-category', {
          params: {
            start_date,
            end_date,
          },
        });
        setWebhookCategoryLogs(response.data);
        setLoading(false);
      } catch {
        setLoading(false);
      }
    },
    [api, filters.start_date, filters.end_date],
  );

  const tableColumns: ITableColumn[] = [
    {
      id: v4(),
      name: 'Data',
      dataIndex: 'webhook_received_at',
      responsive: true,
    },
    {
      id: v4(),
      name: 'Categoria',
      dataIndex: 'category',
      responsive: false,
    },
    {
      id: v4(),
      name: 'Conteúdo',
      dataIndex: 'content',
      responsive: false,
    },
  ];

  const headerActions: IActionHeaderConfig[] = [
    {
      titleAction: 'Filtros',
      icon: <FaFilter />,
      action: () => {
        setShowFilters(true);
      },
    },
    {
      titleAction: 'Atualizar',
      icon: <FaSyncAlt />,
      action: () => {
        loadLogs();
      },
    },
  ];

  const onSearch = useCallback(
    (start_date: string, end_date: string) => {
      setFilters({ start_date, end_date });
      loadLogs(start_date, end_date);
      setShowFilters(false);
    },
    [loadLogs],
  );

  return (
    <Card>
      <Table
        title="Templates Webhooks"
        actionsConfig={headerActions}
        data={webhookCategoryLogs}
        keyIndex="date"
        tableColumns={tableColumns}
        action={false}
        isPaginated={false}
        loading={loading}
      />

      <LogWebhookCategoryFilters
        closeFilters={() => setShowFilters(false)}
        showFilters={showFilters}
        search={onSearch}
      />
    </Card>
  );
};

export default LogWebhookCategory;
